///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2025
//                                    RXO Inc.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of RXO Inc. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { useSelector, useDispatch } from "react-redux";

import { sortPendingBids } from "../../slices/pendingBidsSlice";
import { pendingBidsSortableFields } from "../../helpers/types";
import messages from "../../helpers/messages";
import HeaderCell from "../HeaderCell";

const PendingBidsTableHeader = () => {
  const dispatch = useDispatch();

  const { sortField, sortOrder, isFetching } = useSelector(
    state => state.pendingBids
  );

  const sortBids = ({ fieldName, sortReverse }) =>
    dispatch(sortPendingBids({ fieldName, sortReverse }));

  return (
    <thead>
      <tr className="header-row">
        <HeaderCell
          className="left"
          label={messages.uniqueBidName.defaultMessage}
          fieldName={pendingBidsSortableFields.rfqName}
          sortBids={sortBids}
          sortField={sortField}
          sortOrder={sortOrder}
          isFetching={isFetching}
        />
        <HeaderCell
          className="left"
          label={messages.bidCreator.defaultMessage}
          fieldName={pendingBidsSortableFields.mainRepFullName}
          sortBids={sortBids}
          sortField={sortField}
          sortOrder={sortOrder}
          isFetching={isFetching}
        />
        <HeaderCell
          className="left"
          label={messages.accountName.defaultMessage}
          fieldName={pendingBidsSortableFields.shipperName}
          sortBids={sortBids}
          sortField={sortField}
          sortOrder={sortOrder}
          isFetching={isFetching}
        />
        <HeaderCell
          className="left"
          label={messages.deadline.defaultMessage}
          fieldName={pendingBidsSortableFields.deadline}
          sortBids={sortBids}
          sortField={sortField}
          sortOrder={sortOrder}
          isFetching={isFetching}
        />
        <HeaderCell
          className="right"
          arrowLeft
          label={messages.lane.defaultMessage}
          fieldName={pendingBidsSortableFields.laneCount}
          sortBids={sortBids}
          sortField={sortField}
          sortOrder={sortOrder}
          isFetching={isFetching}
        />
        <HeaderCell
          className="right"
          arrowLeft
          label={messages.volume.defaultMessage}
          fieldName={pendingBidsSortableFields.volume}
          sortBids={sortBids}
          sortField={sortField}
          sortOrder={sortOrder}
          isFetching={isFetching}
        />
        <HeaderCell
          className="left"
          label={messages.mode.defaultMessage}
          fieldName={pendingBidsSortableFields.mode}
          sortBids={sortBids}
          sortField={sortField}
          sortOrder={sortOrder}
          isFetching={isFetching}
        />
        <HeaderCell
          className="right"
          arrowLeft
          label={messages.pending.defaultMessage}
          fieldName={pendingBidsSortableFields.pending}
          sortReverse
          sortBids={sortBids}
          sortField={sortField}
          sortOrder={sortOrder}
          isFetching={isFetching}
        />
        <HeaderCell
          label={messages.actions.defaultMessage}
          sortField={sortField}
          sortOrder={sortOrder}
          isFetching={isFetching}
          className=""
        />
      </tr>
    </thead>
  );
};

export default PendingBidsTableHeader;
